import helper from '@/lib/helper'

export const landmarkQuiz = {
    "code": "",
    "title": "Landmarks",
    "image": "https://thebigquiz.net/uploads/668e43ea0149be11a808d983/2024/08/83949b54223d50f559.jpeg?r=03135",
    "image_original": "https://thebigquiz.net/uploads/668e43ea0149be11a808d983/2024/08/f4ff1bd1565464ef98.webp?r=02015",
    "image_placeholder": "no-image3.png",
    "image_source": "",
    "image_coordinates": [],
    "video": null,
    "description": "Whether you're a geography buff or just love to travel, this quiz will challenge and entertain you with questions about the history, location, and significance of the world's most renowned landmarks. Can you identify them all?",
    "custom_message": "",
    "is_random_question_order": true,
    "background_color": "#ef0000",
    "background_image": null,
    "background_image_original": "",
    "background_image_source": "",
    "background_image_coordinates": [],
    "background_image_blur": 0,
    "background_image_darken": 50,
    "background_image_opacity": 50,
    "background_video": "",
    "background_type": "color",
    "background_music": {
        "id": 0,
        "name": "",
        "src": "",
        "is_playing": "",
        "volume": 0
    },
    "type": "quiz",
    "show_result_on_user_device": false,
    "questions": [{
        "uid": helper.randomUid(),
        "title": "Which famous landmark is known for its clock tower and is located in London, England?",
        "question_type": "basic",
        "answers_count": 1,
        "answers_required": "one",
        "image": "https://thebigquiz.net/uploads/668e43ea0149be11a808d983/2024/08/4c4cfe6c0c5f563950.jpeg?r=05552",
        "image_source": "http://photoeverywhere.co.uk/britain/london/slides/bigben5316.htm",
        "image_original": "https://thebigquiz.net/uploads/imgext/2024/08/3a3db9f07a633e8c04c0a649adff9aad.jpg",
        "image_coordinates": {
            "width": 1536,
            "height": 1536,
            "top": 420.57142857142856,
            "left": 0
        },
        "type": "question",
        "spotify_track": null,
        "video_loop": false,
        "fullscreen_desktop": false,
        "fullscreen_mobile": false,
        "show_full_width_image_mobile": false,
        "is_anywhere": false,
        "status": true,
        "chart_type": "bar",
        "custom_message": "",
        "tags": [],
        "answers": [{
            "title": "The Eiffel Tower",
            "is_correct": false,
            "score": 0,
            "data": {
                "sorting_choice": [],
                "accept_percentage": 0,
                "completely_correct": true
            },
            "image": "",
            "image_coordinates": [],
            "image_original": "",
            "image_source": ""
        }, {
            "title": "Big Ben",
            "is_correct": true,
            "score": 0,
            "data": {
                "sorting_choice": [],
                "accept_percentage": 0,
                "completely_correct": true
            },
            "image": "",
            "image_coordinates": [],
            "image_original": "",
            "image_source": ""
        }, {
            "title": "The Statue of Liberty",
            "is_correct": false,
            "score": 0,
            "data": {
                "sorting_choice": [],
                "accept_percentage": 0,
                "completely_correct": true
            },
            "image": "",
            "image_coordinates": [],
            "image_original": "",
            "image_source": ""
        }],
        "raw": "Q: Which famous landmark is known for its clock tower and is located in London, England?<br>A: The Eiffel Tower<br>B: Big Ben<br>C: The Statue of Liberty<br>Crr: B"
    }, {
        "uid": helper.randomUid(),
        "title": "Which famous landmark is a large ancient amphitheater located in Rome, Italy?",
        "question_type": "basic",
        "answers_count": 1,
        "answers_required": "one",
        "image": "https://thebigquiz.net/uploads/668e43ea0149be11a808d983/2024/08/aa3f247de7e0fb0747.jpeg?r=04805",
        "image_source": "http://en.wikipedia.org/wiki/File:Colosseum_2007.jpg",
        "image_original": "https://thebigquiz.net/uploads/imgext/2024/08/d8187b31bc2d5eeabcb139297f6ae70e.jpg",
        "image_coordinates": {
            "width": 1704,
            "height": 1704,
            "top": 0,
            "left": 284
        },
        "type": "question",
        "spotify_track": null,
        "video_loop": false,
        "fullscreen_desktop": false,
        "fullscreen_mobile": false,
        "show_full_width_image_mobile": false,
        "is_anywhere": false,
        "status": true,
        "chart_type": "bar",
        "custom_message": "",
        "tags": [],
        "answers": [{
            "title": "The Pyramids of Giza",
            "is_correct": false,
            "score": 0,
            "data": {
                "sorting_choice": [],
                "accept_percentage": 0,
                "completely_correct": true
            },
            "image": "",
            "image_coordinates": [],
            "image_original": "",
            "image_source": ""
        }, {
            "title": "The Colosseum",
            "is_correct": true,
            "score": 0,
            "data": {
                "sorting_choice": [],
                "accept_percentage": 0,
                "completely_correct": true
            },
            "image": "",
            "image_coordinates": [],
            "image_original": "",
            "image_source": ""
        }, {
            "title": "The Great Wall of China",
            "is_correct": false,
            "score": 0,
            "data": {
                "sorting_choice": [],
                "accept_percentage": 0,
                "completely_correct": true
            },
            "image": "",
            "image_coordinates": [],
            "image_original": "",
            "image_source": ""
        }],
        "raw": "Q: Which famous landmark is a large ancient amphitheater located in Rome, Italy?<br>A: The Pyramids of Giza<br>B: The Colosseum<br>C: The Great Wall of China<br>Crr: B"
    }, {
        "uid": helper.randomUid(),
        "title": "Which famous landmark is a historical fortress and former prison located on an island in San Francisco Bay, USA?",
        "question_type": "basic",
        "answers_count": 1,
        "answers_required": "one",
        "image": "https://thebigquiz.net/uploads/668e43ea0149be11a808d983/2024/08/45a1c239d04ff27a91.jpeg?r=00097",
        "image_original": "https://thebigquiz.net/uploads/imgext/2024/08/56fe55e545f7d8cc4b410e446ba54bd4.jpg",
        "image_coordinates": [],
        "type": "question",
        "spotify_track": null,
        "video_loop": false,
        "fullscreen_desktop": true,
        "fullscreen_mobile": true,
        "show_full_width_image_mobile": false,
        "is_anywhere": false,
        "status": true,
        "chart_type": "bar",
        "custom_message": "",
        "tags": [],
        "answers": [{
            "title": "Alcatraz Island",
            "is_correct": true,
            "score": 0,
            "data": {
                "sorting_choice": [],
                "accept_percentage": 0,
                "completely_correct": true
            },
            "image": "",
            "image_coordinates": [],
            "image_original": "",
            "image_source": ""
        }, {
            "title": "Golden Gate Bridge",
            "is_correct": false,
            "score": 0,
            "data": {
                "sorting_choice": [],
                "accept_percentage": 0,
                "completely_correct": true
            },
            "image": "",
            "image_coordinates": [],
            "image_original": "",
            "image_source": ""
        }, {
            "title": "Statue of Liberty",
            "is_correct": false,
            "score": 0,
            "data": {
                "sorting_choice": [],
                "accept_percentage": 0,
                "completely_correct": true
            },
            "image": "",
            "image_coordinates": [],
            "image_original": "",
            "image_source": ""
        }],
        "raw": "Q: Which famous landmark is a historical fortress and former prison located on an island in San Francisco Bay, USA?<br>A: Alcatraz Island<br>B: Golden Gate Bridge<br>C: Statue of Liberty<br>Crr: A"
    }, {
        "uid": helper.randomUid(),
        "title": "Which giant statue located in Rio de Janeiro, Brazil, and is one of the New Seven Wonders of the World?",
        "question_type": "basic",
        "answers_count": 1,
        "answers_required": "one",
        "image": "https://thebigquiz.net/uploads/668e43ea0149be11a808d983/2024/08/7bc0437d77abd14965.jpeg?r=02196",
        "image_source": "http://www.travelthewholeworld.org/2016/03/the-seven-wonders-of-the-world-look-totally-different-in-these-unique-photos.html",
        "image_original": "https://thebigquiz.net/uploads/imgext/2024/08/31eda4754a2ddd744a1861ffe681e4dd.jpg",
        "image_coordinates": {
            "width": 575.0000000000005,
            "height": 575.0000000000005,
            "top": 192.36111111111074,
            "left": 296.5277777777776
        },
        "type": "question",
        "spotify_track": null,
        "video_loop": false,
        "fullscreen_desktop": false,
        "fullscreen_mobile": false,
        "show_full_width_image_mobile": true,
        "is_anywhere": false,
        "status": true,
        "chart_type": "bar",
        "custom_message": "",
        "tags": [],
        "answers": [{
            "title": "Christ the Redeemer",
            "is_correct": true,
            "score": 0,
            "data": {
                "sorting_choice": [],
                "accept_percentage": 0,
                "completely_correct": true
            },
            "image": "",
            "image_coordinates": [],
            "image_original": "",
            "image_source": ""
        }, {
            "title": "The Statue of Liberty",
            "is_correct": false,
            "score": 0,
            "data": {
                "sorting_choice": [],
                "accept_percentage": 0,
                "completely_correct": true
            },
            "image": "",
            "image_coordinates": [],
            "image_original": "",
            "image_source": ""
        }, {
            "title": "The Eiffel Tower",
            "is_correct": false,
            "score": 0,
            "data": {
                "sorting_choice": [],
                "accept_percentage": 0,
                "completely_correct": true
            },
            "image": "",
            "image_coordinates": [],
            "image_original": "",
            "image_source": ""
        }, {
            "title": "The Pyramids",
            "image": "",
            "is_correct": false,
            "score": 0,
            "data": {
                "sorting_choices": [],
                "accepted_percentage": 0,
                "completely_correct": true
            }
        }],
        "raw": "Q: Which famous landmark is a giant statue located in Rio de Janeiro, Brazil, and is one of the New Seven Wonders of the World?<br>A: Christ the Redeemer<br>B: The Statue of Liberty<br>C: The Eiffel Tower<br>Crr: A"
    }, {
        "uid": helper.randomUid(),
        "title": "Which enormous stone structure built by the ancient Egyptians and is one of the Seven Wonders of the Ancient World?",
        "question_type": "basic",
        "answers_count": 1,
        "answers_required": "one",
        "image": "",
        "type": "question",
        "spotify_track": null,
        "video_loop": false,
        "fullscreen_desktop": false,
        "fullscreen_mobile": false,
        "show_full_width_image_mobile": false,
        "is_anywhere": false,
        "status": true,
        "chart_type": "bar",
        "custom_message": "",
        "tags": [],
        "answers": [{
            "title": "",
            "is_correct": true,
            "score": 0,
            "data": {
                "sorting_choice": [],
                "accept_percentage": 0,
                "completely_correct": true
            },
            "image": "https://thebigquiz.net/uploads/668e43ea0149be11a808d983/2024/08/afbdac93b75b340572.jpeg?r=01288",
            "image_coordinates": {
                "width": 1200,
                "height": 1200,
                "top": 0,
                "left": 200
            },
            "image_original": "https://thebigquiz.net/uploads/imgext/2024/08/67e2c405cc3c0d474966a95c754a3a85.jpg",
            "image_source": "http://the12thhs.blogspot.com/2010/11/who-built-pyramids-at-giza-and-when.html"
        }, {
            "title": "",
            "is_correct": false,
            "score": 0,
            "data": {
                "sorting_choice": [],
                "accept_percentage": 0,
                "completely_correct": true
            },
            "image": "https://thebigquiz.net/uploads/668e43ea0149be11a808d983/2024/08/c4b1556fab1f6b5341.jpeg?r=06765",
            "image_coordinates": {
                "width": 1362.136005041521,
                "height": 1362.136005041521,
                "top": 7.830376862182405,
                "left": 191.30382287606463
            },
            "image_original": "https://thebigquiz.net/uploads/imgext/2024/08/67721ffe778e20715a198fe032ae4875.jpg",
            "image_source": "https://en.wikipedia.org/wiki/File:Liberty-statue-from-below_cropped.jpg"
        }],
        "raw": "Q: Which famous landmark is an enormous stone structure built by the ancient Egyptians and is one of the Seven Wonders of the Ancient World?<br>A: The Great Wall of China<br>B: The Pyramids of Giza<br>C: The Statue of Liberty<br>Crr: B"
    }],
    "approval_status": "",
    "tags": [],
    "countries": [],
    "age": [0, 99],
    "difficult": 5,
    "limit_player": 10,
    "show_number_question": 10,
    "show_correct_answer": true,
    "playing_counter": 0,
    "class_subject": null,
    "class_grade": [],
    "show_school_list": false,
    "show_school_country_list": false,
    "school_id": null,
    "status": false,
    "theme_name": "theme_1",
    "themes": {
        "theme_1": {
            "name": "theme_1",
            "question_text_color": "#ffffff",
            "question_shadow_color": "#073763",
            "button_text_color": "#ffffff",
            "ui_color": "#ffffff",
            "button_color": "#3d85c6",
            "background_image": "https://thebigquiz.net/uploads/668e43ea0149be11a808d983/2024/08/7a483df4ba4f4d0419.jpeg?r=06080",
            "background_image_source": "",
            "background_image_original": "https://thebigquiz.net/uploads/668e43ea0149be11a808d983/2024/08/53248785872ad5b198.webp?r=07968",
            "background_image_coordinates": [],
            "background_color": "#073763"
        },
        "theme_2": {
            "name": "theme_2",
            "question_text_color": "#000000",
            "question_shadow_color": "",
            "button_text_color": "#ffffff",
            "ui_color": "#21B6A8",
            "button_color": "#18A558",
            "background_image": "",
            "background_image_source": "",
            "background_image_original": "",
            "background_image_coordinates": [],
            "background_color": "#cc0000"
        },
        "theme_3": {
            "name": "theme_3",
            "question_text_color": "#000000",
            "question_shadow_color": "",
            "button_text_color": "#ffffff",
            "ui_color": "#B8860B",
            "button_color": "#FF8C00",
            "background_image": "",
            "background_image_source": "",
            "background_image_original": "",
            "background_image_coordinates": [],
            "background_color": "#cc0000"
        }
    },
    "captcha_response": "",
    "share_setting": {
        "can_read": false,
        "can_edit": false,
        "can_access_report": false,
    }
}
